import { useState } from 'react';
import { useNavigate, createSearchParams } from 'react-router-dom';
import {
  Grid,
  Typography,
  InputAdornment,
  Button,
  TextField,
  Box,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import Search from '@mui/icons-material/Search';
import { grey } from '@mui/material/colors';
import { useApp } from '../../../../context/appContext';
import { PATH } from '../../../../config/path';

const App = ({heroImage, title, subTitle, topService}) => {
  const theme = useTheme();
  const mobileView = useMediaQuery(theme.breakpoints.down('sm'));
  const tabletView = useMediaQuery(theme.breakpoints.between('sm', 'lg'));
  const { getImageAsset } = useApp();

  const [search, setSearch] = useState();

  const navigate = useNavigate();

  const handleSearch = () => {
    if (!search) {
      return;
    }
    // navigate({
    //   pathname: PATH.DESTINATION,
    //   search: `?${createSearchParams({ search: search })}`,
    // });
    const slug = search
      .toString()
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^\w-]+/g, '');

    navigate(`${PATH.DESTINATION}/${slug}`);
  }; 

  const getHeroImage = () => {
    // if (mobileView) return getImageAsset('hero-mobile');
    // if (tabletView) return getImageAsset('hero-tablet');
    return getImageAsset('hero');
  };

  return (
    <Box
      sx={{
        bgcolor: grey[100],
        height: {
          xs: '70vh',
        },
        position: 'relative',
      }}>
      <Box
        component={'img'}
        alt={heroImage?.image_title}
        loading="lazy"
        src={heroImage?.image}
        width={'100%'}
        height={'100%'}
        sx={{
          objectFit: 'cover',
        }}
      />

      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
        }}>
        <Box
          sx={{
            px: {
              xs: 2,
            },
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            width: '100%',
            gap: {
              xs: 2,
              md: 3,
            },
          }}>
          <Box>
            <Typography
              variant="body1"
              align="center"
              sx={{
                color: '#fff',
                fontSize: {
                  xs: 18,
                  sm: 50,
                  xl: 58,
                },
                fontWeight: 500,
              }}>
              {title?.content}
            </Typography>

            <Typography
              variant="body1"
              align="center"
              sx={{
                color: '#fff',
                fontSize: {
                  xs: 18,
                  sm: 36,
                  xl: 40,
                },
                fontWeight: 500,
                mt: -0.5,
              }}>
              {subTitle?.content}
            </Typography>
          </Box>

          <Grid container justifyContent="center">
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                display: 'flex',
                gap: {
                  xs: 1,
                  md: 2,
                },
                '& .MuiFormControl-fullWidth': {
                  borderRadius: 1,
                },
              }}>
              <TextField
                id="input-with-icon-textfield"
                placeholder="Search destinations, tours, activities"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Search />
                    </InputAdornment>
                  ),
                }}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    handleSearch();
                  }
                }}
                variant="outlined"
                fullWidth
                sx={{
                  backgroundColor: '#fff',
                  opacity: 0.8,
                  '&:hover': {
                    opacity: 1,
                  },
                  '& .MuiOutlinedInput-input:focus': {
                    opacity: 1,
                  },
                  '& fieldset': {
                    border: 'none',
                  },
                }}
              />
              <Button variant="contained" color="primary" onClick={handleSearch}>
                Search
              </Button>
            </Grid>
          </Grid>

          <Grid container justifyContent="center">
            <Grid
              item
              xs={12}
              md={8}
              container
              spacing={{ xs: 2, md: 3 }}
              sx={{
                maxWidth: "100%",
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              {
              // [
              //   { img: "best-price", text: "Best Price Guarantee" },
              //   { img: "no-booking-fee", text: "No Credit Card or Booking Fees" },
              //   { img: "247-support", text: "24/7 Customer Support" },
              //   {
              //     img: "best-review",
              //     text: "4.9 Rate Review Based on GetYourGuide",
              //     redirect:
              //       "https://www.getyourguide.com/en-gb/surabaya-l348/start-from-surabaya-mount-bromo-sunrise-shared-guided-tour-t862171/?ranking_uuid=c10d4625-33b4-46ef-85e9-bb7ace40a970",
              //   },
              // ]
              topService?.map((item, index) => (
                <Grid
                  item
                  // xs={12}
                  // sm={6}
                  // md={3}
                  key={index}
                  sx={{ display: "flex", justifyContent: "center"}}
                >
                  {item?.redirect_link ? (
                    <a
                      href={item.redirect_link}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none", width: "100%" }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1.5,
                          whiteSpace: "nowrap",
                          cursor: "pointer",
                          textAlign: "center",
                          flexWrap: "wrap",
                          minWidth: "200px",
                        }}
                      >
                        <img
                          // src={getImageAsset(item.img)}
                          src={item?.image}
                          style={{ width: 32, height: 32 }}
                          alt={item?.image_title}
                        />
                        <Typography
                          sx={{
                            fontWeight: 600,
                            color: "white",
                            fontSize: { xs: 12, md: 14 },
                          }}
                        >
                          {item?.content}
                        </Typography>
                      </Box>
                    </a>
                  ) : (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        whiteSpace: "nowrap",
                        textAlign: "center",
                        flexWrap: "wrap",
                        minWidth: "200px",
                      }}
                    >
                      <img
                        // src={getImageAsset(item.img)}
                        src={item?.image}
                        style={{ width: 32, height: 32 }}
                        alt={item?.image_title}
                      />
                      <Typography
                        sx={{
                          fontWeight: 600,
                          color: "white",
                          fontSize: { xs: 12, md: 14 },
                        }}
                      >
                        {item?.content}
                      </Typography>
                    </Box>
                  )}
                </Grid>
              ))}
            </Grid>
          </Grid>

        </Box>
      </Box>
    </Box>
  );
};

export default App;
